// extracted by mini-css-extract-plugin
export default {"wrapper":"RulePageTableRuleCell_wrapper__KbQFg","segments":"RulePageTableRuleCell_segments__icx8K","badge":"RulePageTableRuleCell_badge__LocIV"};